import { getArticleUrl } from '@/client/services/url/faq'

import ShwLink from '@/components/ShwLink'

export default function AgeAssuranceFailureNotice() {
  return (
    <>
      You have failed age verification. Please reach out to{' '}
      <ShwLink href={getArticleUrl('how-do-i-contact-the-schoolhouse-team')}>User Support</ShwLink>{' '}
      to continue
    </>
  )
}
